import { ThemeProvider } from 'styled-components';
import React from 'react';
require('./font_definitions');
const defaultTheme = {
    colors: {
        black: '#000',
        blackLight: '#1B1B1B',
        gray: '#B4C3CC',
        grayLight: '#D2D2D2',
        grayLighter: '#D8E3EC',
        grayDark: '#999999',
        textGrayLight: '#A8A8A8',
        inputGrayBorder: '#D9D9D9',
        inputSymbolColor: '#959EA8',
        toggleGrayLight: '#DAE1E6',
        grayBreadCrumb: '#484848',
        silver: '#969FAA',
        silverLight: '#E0E2E6',
        silverLighter: '#F5F7F9',
        white: '#fff',
        teal: '#00B6DF',
        boxShadow: '#DDD',
        blueLight: '#0BA0F1',
        blueLighter: '#D8E9F4',
        blueVivid: '#2464F2',
        secondaryText: '#008BD6',
        anchorText: '#008BD6',
        tertiaryText: '#6F767F',
        activeNavText: '#808D98',
        inactiveNavText: '#62696F',
        inactiveBreadcrumbText: '#808D98',
        tooltipBackground: '#0C2340',
        tooltipBackgroundLight: '#C8CCD1',
        blueDark: '#005EBB',
        fbButtonBlue: '#1877f2',
        fbButtonWhite: '#fff',
        green: '#36B209',
        toggleGreenLight: '#9DD888',
        greenLighter: '#3FC210',
        statusGreen: '#33B361',
        statusOrange: '#F5A623',
        statusRed: '#9B2128',
        lightStatusRed: '#D94951',
        errorBackground: '#FFEFEF',
        errorBorder: '#FFD4D4',
        textBlue: '#0073B1',
        textLightBlue: '#20AFD7',
        textRed: '#DD3713',
        textOrange: '#E45A25',
        textGray: '#797E89',
        textGreen: '#004A50',
        textGrayDisabled: '#B7B7B7',
        textBlack: '#385032',
        backgroundBlue: '#C3E7FB',
        backgroundBlueLight: '#E3F4FD',
        backgroundBlueLighter: '#F2FFFF',
        backgroundBlueDark: '#181625',
        backgroundGreen: '#D6F5F5',
        backgroundLightGreen: '#A4D896',
        /* @deprecate Use @backgroundGray please! */
        backgroundGrey: '#F9F9FA',
        backgroundGray: '#F9F9FA',
        backgroundOrange: '#E45A25',
        backgroundRed: '#FBCFC6',
        backgroundDarkRed: '#DD3713',
        backgroundLighterDarkRed: '#EC4F34',
        backgroundGrayLight: '#FCFCFC',
        borderRed: '#F54018',
        borderGray: '#F6F6F6',
        borderGrayLight: '#E8ECEE',
        borderGrayDisabled: '#E9E9E9',
        dropDownGray: '#9799A8',
        closeButtonBackgroundGray: '#F1F2F4',
        tabBackgroundGray: '#F4F5FA',
        tabBorderGray: '#E2E3E6',
        tabBorderActiveGray: '#C4C6CB',
        tabBorderGrayLight: '#DDE1E5',
        tabTableBackgroundGray: '#FAFAFA',
        navPrimary: '#232323',
        navPrimaryBorder: '#111111',
        navSecondary: '#333333',
        navTertiary: '#F9F9F9',
        navTertiaryHighlight: '#F2F2F2',
        footerLinkGray: '#717577',
        inputOverlayGray: '#ECECEC',
    },
    seriesColors: ['#68BB0D', '#0BA0F1', '#EB4C2D', '#8027BC', '#0289D8', '#28B59E'],
    seriesCompareColor: '#9E9E9E',
    heatMapBaseColor: '0, 131, 193',
    boxShadows: {
        soft: '0 2px 10px rgba(90, 97, 102, 0.4)'
    },
    fonts: {
        regular: '\'AL-AvenirNext-Regular\', sans-serif',
        medium: '\'AL-AvenirNext-Medium\', sans-serif',
        heavy: '\'Avenir-Heavy\', sans-serif',
        demi: '\'AL-AvenirNext-Demi\', sans-serif',
        demiBold: '\'AL-AvenirNext-DemiBold\', sans-serif',
        black: '\'Avenir-Black\', sans-serif',
        roman: '\'Avenir-Roman\', sans-serif',
        light: '\'Avenir-Light\', sans-serif',
    },
    glyphs: {
        addPrimary: require('../../assets/images/glyphs/add_pri.svg'),
        addSecondary: require('../../assets/images/glyphs/add_sec.svg'),
        backTertiary: require('../../assets/images/glyphs/back_tre.svg'),
        editSecondary: require('../../assets/images/glyphs/edit_sec.svg'),
        filterSecondary: require('../../assets/images/glyphs/filter_sec.svg'),
        filterTertiary: require('../../assets/images/glyphs/filter_tre.svg'),
        savePrimary: require('../../assets/images/glyphs/save_pri.svg'),
        viewSecondary: require('../../assets/images/glyphs/view_sec.svg')
    }
};
const DefaultTheme = ({ children }) => React.createElement(ThemeProvider, { theme: defaultTheme }, children);
// Export default theme
export { DefaultTheme as default, defaultTheme, };
//# sourceMappingURL=index.js.map